import axios from 'axios';
import cookies from 'vue-cookies'
import fallbackActingUserDetails from '../../utils/acting_user/fallback-user-details.js';
// import isEmpty from "lodash/isEmpty";
import mediaService from "../../services/media-service.js"
import Vue from 'vue';

const MODULES_PATH = '/rest/v4/modules';

export default {
  namespaced: true,
  state: {
    actingUserDetails: fallbackActingUserDetails,
    userToActFor: null,
    deputyTypeId: null,
    preselectedPrinter: undefined,
  },
  mutations: {
    setActingUserDetails(state, actingUserDetails) {
      state.actingUserDetails = actingUserDetails;
    },
    clearActingUserDetails(state) {
      state.actingUserDetails = fallbackActingUserDetails;
      state.actingUserDetails = fallbackActingUserDetails;
      sessionStorage.clear();
    },
    setUserToActFor(state, userId) {
      state.userToActFor = userId;
    },
    setDeputyTypeId(state, deputyTypeId) {
      state.deputyTypeId = deputyTypeId;
    },
    setPreselectedPrinter(state, printer) {
      state.preselectedPrinter = printer;
    },
    resetState(state) {
      Vue.set(state, 'actingUserDetails', fallbackActingUserDetails);
      Vue.set(state, 'userToActFor', null);
    },
  },
  actions: {
    async refreshActingUserDetails({ dispatch }) {
      if (cookies.get('token')?.startsWith('-extern-'))
        return;

      try {
        const actingUserResponse = await axios.get('/rest/v4/users/acting');
        const actingUser = actingUserResponse.data.data;
        const responseModules = await axios.get(MODULES_PATH);
        actingUser.navigation = _flattenModules(responseModules.data.data);
        await dispatch('setActingUserDetails', actingUser);
        return actingUser;
      } catch (e) {
        window.console.error(e);
      }
    },
    clearActingUserDetails({ commit }) {
      commit('clearActingUserDetails');
    },
    async setActingUserDetails({ commit }, actingUserDetails) {
      async function getImage() {
        if (actingUserDetails.imgSrc === null) {
          return require('../../assets/header/default_profile_img.jpg');
        } else {
          try {
            return await mediaService.loadWorkFileAsImage(actingUserDetails.imgSrc);
          } catch (err) {
            return require('../../assets/header/default_profile_img.jpg');
          }
        }
      }

      try {
        const img = await getImage();
        actingUserDetails.imgSrc = img;
        commit('setActingUserDetails', actingUserDetails);
      } catch (error) {
        commit('setActingUserDetails', actingUserDetails);
      }
    },
    resetState({ commit }) {
      commit('resetState');
    },
    setPreselectedPrinter({ commit }, printer) {
      commit('setPreselectedPrinter', printer);
    },
  },
  getters: {
    getActingUserDetails: (state) => state.actingUserDetails,
    isUserAllowedToSeeModule: (state) => (moduleId) => {
      return (
        state.actingUserDetails.navigation.findIndex(
          (_moduleId) => _moduleId == moduleId
        ) >= 0
      );
    },
    getPreselectedPrinter: (state) => state.preselectedPrinter,
    getUserToActFor: (state) => state.userToActFor,
  },
};

const _flattenModules = (modules) => {
    return modules.map((_module) => _module.moduleId);
}
